import {CellValueTextDefaultBox} from './cell-value-text.default.box';
import {CellValueTextCasino777Box} from './cell-value-text.casino777.box';
import {CellValueTextMrGreenBox} from './cell-value-text.mrgeen.box';
import {styledByTheme} from '../../../../../../../../themes/architecture/styled-by-theme';

export const CellValueTextBox = styledByTheme(CellValueTextDefaultBox)
.forCasino777(CellValueTextCasino777Box)
.forMrGreen(CellValueTextMrGreenBox)
.apply();